type CsvValue = string | number | boolean | null | undefined;

function escapeCsvValue(value: CsvValue, delimiter: string) {
  const normalizedValue = value == null ? '' : String(value);

  if (
    normalizedValue.includes('"') ||
    normalizedValue.includes('\n') ||
    normalizedValue.includes('\r') ||
    normalizedValue.includes(delimiter)
  ) {
    return `"${normalizedValue.replace(/"/g, '""')}"`;
  }

  return normalizedValue;
}

export function createCsvContent(headers: string[], rows: CsvValue[][], delimiter = ';') {
  const csvRows = [headers, ...rows].map((row) =>
    row.map((value) => escapeCsvValue(value, delimiter)).join(delimiter)
  );

  return `\uFEFF${csvRows.join('\r\n')}`;
}

export function downloadCsv(headers: string[], rows: CsvValue[][], name: string, delimiter = ';') {
  const csvContent = createCsvContent(headers, rows, delimiter);
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);

  link.href = url;
  link.download = `${name}.csv`;

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  URL.revokeObjectURL(url);
}
